// The one mark for an Uber figure's state. Each state has its own look so the
// three are never mistaken for each other or for a warning: Received is green,
// Earned is blue, Forecast is a dashed outline in the muted colour, and an
// unknown amount is amber.
import { Chip } from '../interviews/Chip'
import { cn } from '../../lib/shadcn/utils'
import { stateLabel, type UberState } from '../../utils/cashPlan'

const EARNED = 'bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-200 dark:border-sky-800'
const FORECAST = 'bg-transparent border-dashed text-muted-foreground'

export function StateChip({ state, prefix, className }: { state: UberState | null | undefined; prefix?: string; className?: string }) {
  const tone = state === 'received' ? 'green' : state === 'unknown' || !state ? 'amber' : 'neutral'
  return (
    <Chip tone={tone} className={cn(state === 'earned' && EARNED, state === 'forecast' && FORECAST, 'not-italic', className)}>
      {prefix ? `${prefix}: ` : ''}{stateLabel(state)}
    </Chip>
  )
}
